"use server";

import { headers } from "next/headers";
import { sendToDocvivo } from "@/lib/docvivo";
import { sendLeadEmail } from "@/lib/mailer";

interface ContactSubmitData {
      name: string;
      number: string;
      email?: string;
      mesaji?: string;
      sourceUrl?: string;
}

async function getClientIp(): Promise<string> {
      const headersList = await headers();
      return (
            headersList.get("x-forwarded-for")?.split(",")[0]?.trim() ||
            headersList.get("x-real-ip") ||
            "0.0.0.0"
      );
}

function sourceLabel(url?: string): string {
      if (!url) return "Web Sitesi";
      try {
            const path = new URL(url).pathname;
            if (path === "/" || path === "") return "Ana Sayfa";
            return path.replace(/^\//, "").replace(/-/g, " ");
      } catch {
            return url;
      }
}

export async function submitContactForm(data: ContactSubmitData) {
      try {
            // 1) Strapi'ye kaydet
            const strapiRes = await fetch(
                  `${process.env.NEXT_PUBLIC_API_URL}/api/form-talepleris`,
                  {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                              data: {
                                    name: data.name,
                                    number: data.number,
                                    email: data.email || "",
                                    mesaji: data.mesaji || "",
                              },
                        }),
                  }
            );

            if (!strapiRes.ok) {
                  console.error("Strapi kayıt hatası:", await strapiRes.text());
                  return { success: false, message: "Sunucu hatası oluştu." };
            }

            // 2) E-posta gönder
            try {
                  await sendLeadEmail({
                        name: data.name,
                        phone: data.number,
                        email: data.email,
                        message: data.mesaji,
                        source: sourceLabel(data.sourceUrl),
                  });
            } catch (mailErr) {
                  console.error("E-posta gönderilemedi:", mailErr);
            }

            // 3) Docvivo CRM
            await sendToDocvivo({
                  name: data.name,
                  phone: data.number,
                  sourceUrl: data.sourceUrl || "https://wolisticcenter.com",
                  ipAddress: await getClientIp(),
                  email: data.email || undefined,
                  address: data.mesaji || undefined,
            });

            return { success: true };
      } catch (error) {
            console.error("Contact form hatası:", error);
            return { success: false, message: "Bir hata oluştu." };
      }
}
